<template>
<el-dropdown trigger="click">
    <span class="el-dropdown-link">
        <div>
            <i class="icon-ring" @click="open()"></i>
            <span v-if="newNotification" class="circle-icon"></span>
        </div>
    </span>
    <el-dropdown-menu slot="dropdown" class="sa-notific" v-show="aflag">
        <div v-if="!isHidden">
            <div class="notifc-header">
                <div class="d-space-center m-b10"><strong>Notification</strong>
                </div>
                <ul class="lab-pack badge-cont">
                    <li @click="tabs = 'tab1'" :class="tabs === 'tab1' ? 'active' : ''">
                        <span>All<span class="badge badge-bg"> {{allCount}} </span></span>
                    </li>
                    <li @click="tabs = 'tab2'" :class="tabs === 'tab2' ? 'active' : ''">
                        <span>Service Request<span class="badge"> {{serviceCount}} </span></span>
                    </li>
                </ul>
                <template v-if="tabs === 'tab1'">
                    <all-notifications ref="notify" :key="count" @allCountEvent="allCount = $event" @serviceReqEvent="serviceCount = $event"/>
                </template>
                <template v-if="tabs === 'tab2'">
                    <all-notifications />
                </template>
            </div>
            <div class="d-space-center">
                <span>
                    <span class="text-underline" @click="getReadNotificationList()">Mark all as read</span></span>
                <el-button v-if="showNotification" type="primary" size="small" @click="showNotificationTab">View all Notification</el-button>
            </div>
        </div>

        <div v-if="isHidden">
            <div class="d-space-center m-b10"><strong>Notification</strong>
                <span @click="closeTab"><i class="icon-arrow-right icon-cir-cross"></i></span>
            </div>
            <p class="gray-color m-b10"> Show only selected notifications </p>
            <notification-settings ref="notifyRef" />

            <div class="d-space-center">
                <span><i class="icon-settings  primary-color"></i><span>Settings</span></span>
                <el-button type="primary" size="small" @click="save()">Save Settings</el-button>
            </div>
        </div>

    </el-dropdown-menu>
    <div v-if="nLoader" class="loading"></div>
</el-dropdown>
</template>

<script>
import API from '../../services/api';
import AllNotifications from "./AllNotifications.vue"
import NotificationSettings from "./NotificationSettings.vue"
export default {
    components: {
        AllNotifications,
        NotificationSettings
    },
    data() {
        return {
            aflag: false,
            tabs: "tab1",
            isHidden: false,
            toggle: false,
            messages: [],
            page: 1,
            infiniteId: "",
            pageLimit: 10,
            notificationList: [],
            notificationImg: '',
            notificationMsg: '',
            count: 1,
            nLoader: false,
            allCount: 0,
            serviceCount: 0,
            showSettings: false,
            showNotification: false,
            newNotification: false
        }
    },
    mounted() {
         let eventids = JSON.parse(localStorage.getItem('eventids'));
         let _self = this;
         if(eventids && eventids['1471']){
             _self.showSettings = true
         }
        if(eventids && eventids['1472']){
             _self.showNotification = true
         }
        let nfy = localStorage.getItem('notification')
        if(nfy === 'true') {
            this.newNotification = true
        }
    },
    created() {},
    methods: {
        getReadNotificationList() {
            let _self = this
            _self.nLoader = true
            let notifyReff = _self.$refs.notify
            API.getReadNotifications(function (response) {
                if (response && response.status === 1000) {
                    _self.nLoader = false
                    _self.count = _self.count + 1
                    notifyReff.getNotifications()
                } else {
                    _self.$message({
                        message: "Error while updating",
                        type: 'error',
                    });

                }
            });
        },
        save() {
            let self = this
            self.isHidden = false
            self.aflag = false
            let nRef = self.$refs.notifyRef
            nRef.saveNotificationList()
        },
        showNotificationTab() {
            this.aflag = false
            this.$router.push({
                path: "/notifications/notify"
            });
        },
        open() {
            this.aflag = true
            localStorage.setItem('notification', false)
            this.newNotification = false
        },
        showComp() {
            this.isHidden = true
        },
        closeTab() {
            this.isHidden = false
        },
        close() {
            this.aflag = false
        },
    },
    computed: {
        inAppNotification() {
            return this.$store.getters["common/getInAppNotification"]
        }
    },
    watch: {
        inAppNotification() {
            if (this.inAppNotification) {
                localStorage.setItem('notification', true)
                this.newNotification = true
            }
        }
    }
}
</script>

<style>
.circle-icon{
    background-color: #F56C6C; 
    border-radius: 10px; 
    color: #FFF; 
    display: inline-block; 
    font-size: 12px;
    height: 8px; 
    line-height: 8px; 
    padding: 0 4px; 
    text-align: center; 
    white-space: nowrap; 
    top: 4px; 
    position: absolute; 
    right: 16px;
}
.sa-notific {
    width: 450px;
    top: 55px !important;
    z-index: 9999 !important;
    padding: 15px;
}

.sa-notific-list h6 {
    font-weight: 500;
    padding: 15px 20px;
}

.sa-noti-scroll {
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    border-top: 1px solid #B2C1D8;
    margin: 15px -15px;
    padding-right: 10px;
}

.sa-notific .icon-settings {
    vertical-align: middle;
    margin-right: 10px;
}

.sa-menu-bar .el-badge__content {
    font-size: 8px;
}

.sa-menu-bar .el-badge__content.is-fixed {
    top: 6px;
}

.sa-menu-bar .icon-ring {
    background-color: #b7e4f7;
    width: 30px;
    height: 30px;
    display: block;
    line-height: 30px;
    text-align: center;
    border-radius: 4px;
    color:#000;
    margin-right: 10px;
}

.badge-cont {
    display: flex;
    gap: 15px;
    font-size: 12px;
    color: #88909C;
}

.icon-cir-cross {
    border: 1px solid #B2C1D8;
    padding: 5px;
    font-size: 10px;
    border-radius: 4px;
    font-weight: bold;
}

.sa-noti-cont {
    position: relative;
    width: 100%;padding-left:35px;
}
.sa-noti-cont p {
    word-break: break-word;
    width: 75%;
    font-weight: 500;
    font-size: 12px;
}

.sa-noti-cont-img p {
    color: #88909C;
    font-weight: normal;
    margin-top: 10px;
}
.sa-noti-cont-img p strong,.sa-notific-list li .sa-noti-cont strong {color: #000;font-weight: 500;}

.sa-noti-tim {
    position: absolute;
    right: 0;
    top: 0;
    color: #666;font-size: 11px;
}

.sa-noti-offers {
    padding-left: 40px;
}

.sa-offer-img {
    height: 90px;
    width: 100%;
    overflow: hidden;
    border-radius: 8px;
    margin-top: 5px;
}

.sa-notific-list li {
    width: 100%;
    margin-bottom: 2px;
    color: var(--sa-dark);
    line-height: normal;
    padding: 15px 20px;
    background: #f3fbfe;cursor:pointer;
}

.sa-notific-list li:last-child {
    border-bottom: none;
}

.sa-notific-list h5 {
    padding: 0 20px 10px;
}

.sa-notific-list li.read {
    background: transparent;
}

.sa-notific-list[x-placement^=bottom] .popper__arrow {
    border-bottom-color: #fff;
    border-width: 8px;
    top: -15px;
}

.sa-notific-list li.read:hover {
    background-color: transparent;
    color: #000;
}

.sa-noti-cont-img {
    display: flex;
    justify-content: space-between;
}

.sa-noti-cont-img .sa-ftr-img {
    width: calc(100% - 64px);
}

.icon-results-update,.icon-service-updated {
    color: var(--sa-primary);
    background: #d0ecfc;
}

.icon-closed-appointment {
    color: #dd272b;
    background: #f9ece8;
}

.icon-money-bag-line,.icon-employee-disabled ,.icon-schedule-update{
    color: #34C649;
    background: #d0fcd0;
}
.icon-no-show-doctor,.icon-patient2 {
    color: #e79d13;
    background: #fff8ed;
}
.sa-notific-text-danger {color: #dd272b;}
.sa-notific-text-success {color: #34C649;}
.sa-notific-text-warning {color: #e79d13;}
.sa-notific-text-info {color: var(--sa-primary);}

.sa-menu-bar .el-badge__content.is-fixed { top: 10px; right:15px;border:none;display: flex !important; height: 8px; line-height: 8px;padding:0 4px; }

@media only screen and (max-width: 375px),
only screen and (max-device-width: 375px) {
    .sa-notific {
        width: 350px;
    }

    .badge-cont {
        gap: 10px;
    }
}

@media only screen and (max-width: 320px),
only screen and (max-device-width: 320px) {
    .sa-notific {
        width: 310px;
    }

    .badge-cont {
        font-size: 9px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/notification/Notification.vue